import { BaseFieldWidget, FormM2OSelectFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.ManyToOne,
    widget: 'directOrderPackage',
  })
)
export class TableM2oDirectOrderPackageFieldWidget extends FormM2OSelectFieldWidget {
  initialize(props) {
    super.initialize(props);
    if (this.model.moduleName === 'deliAriesCoreSeller') {
      this.field.domain = `${this.formData.itemTplCode ? `itemTplCode == ${this.formData.itemTplCode} or` : ''} id == ${this.formData.id}`;
    } else {
      this.field.domain = `itemTplCode == ${this.formData.code} or id == ${this.formData.id}`;
    }
    return this;
  }
}